/* Castor Hub — header behaviour (30-10-2026) */
(function () {
  var root = document.querySelector('[data-chh]');
  if (!root) return;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var money = function (v) { var n = parseFloat(v); return isNaN(n) ? '' : '£' + n.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };

  /* sticky state (Horizon may scroll .page-wrapper instead of window) */
  var scrollers = [window, document.querySelector('.page-wrapper')].filter(Boolean);
  var onScroll = function () {
    var y = Math.max(window.scrollY || 0, (document.querySelector('.page-wrapper') || {}).scrollTop || 0);
    root.classList.toggle('is-stuck', y > 40);
  };
  scrollers.forEach(function (s) { s.addEventListener('scroll', onScroll, { passive: true }); });

  /* mega menus: hover intent + click + keyboard */
  var items = root.querySelectorAll('[data-chh-item]');
  var closeAll = function (except) { items.forEach(function (it) { if (it !== except) { it.classList.remove('is-open'); var l = it.querySelector('[data-chh-link]'); if (l) l.setAttribute('aria-expanded', 'false'); } }); };
  items.forEach(function (it) {
    var link = it.querySelector('[data-chh-link]');
    if (!link) return;
    var t;
    var open = function () { closeAll(it); it.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); };
    var close = function () { it.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); };
    it.addEventListener('mouseenter', function () { clearTimeout(t); t = setTimeout(open, 120); });
    it.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(close, 180); });
    link.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: none)').matches && !it.classList.contains('is-open')) { e.preventDefault(); open(); }
    });
    link.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || ((e.key === 'Enter' || e.key === ' ') && !it.classList.contains('is-open'))) { e.preventDefault(); open(); var f = it.querySelector('.chh-mega a'); if (f) f.focus(); }
    });
    it.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); link.focus(); } });
    it.addEventListener('focusout', function (e) { if (!it.contains(e.relatedTarget)) close(); });
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-chh-item]')) closeAll(); });

  /* drawer */
  var drawer = root.querySelector('[data-chh-drawer]');
  var opener = root.querySelector('[data-chh-open]');
  var setDrawer = function (on) {
    if (!drawer) return;
    drawer.hidden = !on;
    if (opener) opener.setAttribute('aria-expanded', on ? 'true' : 'false');
    document.documentElement.style.overflow = on ? 'hidden' : '';
    if (on) { var x = drawer.querySelector('[data-chh-close].chh-drawer__x'); if (x) x.focus(); } else if (opener) opener.focus();
  };
  if (opener) opener.addEventListener('click', function () { setDrawer(true); });
  root.querySelectorAll('[data-chh-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && !drawer.hidden) setDrawer(false); });

  /* basket count */
  var countEls = root.querySelectorAll('[data-chh-count]');
  var refreshCount = function (cart) {
    var apply = function (c) { countEls.forEach(function (el) { el.textContent = c.item_count; }); var b = root.querySelector('.chh-basket'); if (b) b.setAttribute('aria-label', 'Basket, ' + c.item_count + ' items'); };
    if (cart && typeof cart.item_count === 'number') return apply(cart);
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(apply).catch(function () {});
  };
  document.addEventListener('ch:cart-updated', function (e) { refreshCount(e.detail && e.detail.cart); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });

  /* predictive search */
  var form = root.querySelector('[data-chh-search]');
  if (!form) return;
  var input = form.querySelector('[data-chh-q]');
  var box = form.querySelector('[data-chh-sugg]');
  var timer, ctrl, active = -1;
  var popular = ['100mm braked swivel', '125mm swivel plate', 'bolt hole castor', 'polyurethane wheel', 'tube expander', 'twin wheel castor'];
  var show = function (html) { box.innerHTML = html; box.hidden = false; input.setAttribute('aria-expanded', 'true'); active = -1; };
  var hide = function () { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; };
  var empty = function () {
    show('<span class="chh-sugg__h">Popular searches</span><div>' + popular.map(function (p) { return '<a class="chh-sugg__c" role="option" href="/search?type=product&q=' + encodeURIComponent(p) + '">' + esc(p) + '</a>'; }).join('') + '</div>');
  };
  var hl = function (t, q) {
    var safe = esc(t);
    q.split(/\s+/).filter(function (w) { return w.length > 1; }).forEach(function (w) {
      safe = safe.replace(new RegExp('(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>');
    });
    return safe;
  };
  var run = function (q) {
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
      var res = (d.resources && d.resources.results) || {};
      var cols = res.collections || [], prods = res.products || [];
      if (!cols.length && !prods.length) { show('<p class="chh-sugg__none">No matches for “' + esc(q) + '”. Try a size (100mm), a load (150kg) or a type (braked).</p>'); return; }
      var h = '';
      if (cols.length) h += '<span class="chh-sugg__h">Categories</span><div>' + cols.map(function (c) { return '<a class="chh-sugg__c" role="option" href="' + esc(c.url) + '">' + hl(c.title, q) + '</a>'; }).join('') + '</div>';
      if (prods.length) h += '<span class="chh-sugg__h">Products</span>' + prods.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? '<img src="' + esc(p.featured_image.url) + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy" width="48" height="48">' : '<span class="chh-sugg__ph"></span>';
        var from = p.price_min && p.price_max && p.price_min !== p.price_max;
        return '<a class="chh-sugg__p" role="option" href="' + esc(p.url) + '">' + img + '<span class="chh-sugg__t">' + hl(p.title, q) + '</span><span class="chh-sugg__pr">' + (from ? '<small>From</small>' : '') + money(from ? p.price_min : p.price) + '</span></a>';
      }).join('');
      h += '<a class="chh-sugg__all" href="/search?type=product&q=' + encodeURIComponent(q) + '">See all results for “' + esc(q) + '”</a>';
      show(h);
    }).catch(function () {});
  };
  input.addEventListener('focus', function () { if (!input.value.trim()) empty(); });
  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    if (q.length < 2) { empty(); return; }
    timer = setTimeout(function () { run(q); }, 220);
  });
  input.addEventListener('keydown', function (e) {
    var opts = box.querySelectorAll('[role=option]');
    if (e.key === 'Escape') { hide(); return; }
    if (box.hidden || !opts.length) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      active = e.key === 'ArrowDown' ? (active + 1) % opts.length : (active <= 0 ? opts.length - 1 : active - 1);
      opts.forEach(function (o, i) { o.setAttribute('aria-selected', i === active ? 'true' : 'false'); });
      opts[active].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter' && active > -1) { e.preventDefault(); opts[active].click(); }
  });
  document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
})();
